/*
  This file is automatically injected into every "pack" (see: config/webpack/environment.js)
*/
if (!window.postmarkAssetsBaseUrl) {
  throw new Error('"postmarkAssetsBaseUrl" not set!!!')
}

// eslint-disable-next-line no-undef, @typescript-eslint/camelcase
__webpack_public_path__ = window.postmarkAssetsBaseUrl
